import { Controller } from "@hotwired/stimulus";

/** Remove-facility modal: two-option selection and submit state (mirrors intermediary modal). */
export default class extends Controller {
  static targets = ["submitButton", "option"];

  connect() {
    this.reset = this.reset.bind(this);
    this.element.addEventListener("close", this.reset);
    this.reset();
  }

  disconnect() {
    this.element.removeEventListener("close", this.reset);
  }

  reset() {
    this.element.querySelectorAll("input[type=radio]").forEach((radio) => {
      radio.checked = false;
    });
    this.sync();
  }

  sync() {
    this.optionTargets.forEach((option) => {
      option.classList.toggle(
        "is-selected",
        Boolean(option.querySelector(".remove-facility-mode:checked"))
      );
    });

    if (!this.hasSubmitButtonTarget) return;
    const radios = this.element.querySelectorAll(".remove-facility-mode");
    const ok =
      radios.length === 0 ||
      Boolean(this.element.querySelector(".remove-facility-mode:checked"));
    this.submitButtonTarget.disabled = !ok;
    this.submitButtonTarget.setAttribute("aria-disabled", ok ? "false" : "true");
  }
}
